import { render, staticRenderFns } from "./Disabling.vue?vue&type=template&id=5648c732"
import script from "./Disabling.vue?vue&type=script&lang=js"
export * from "./Disabling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports